import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const Property = () => {
  const formBag = useFormContext();

  const {
    options: { PropertyOptions },
  } = useAccountFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.AssociatedAssetId"
      render={({ field: { value, onChange, ref, disabled } }) => (
        <Select
          innerRef={ref}
          isClearable
          label="Property"
          value={PropertyOptions.find(({ value: v }) => value === v)}
          options={PropertyOptions}
          onChange={opt => onChange(opt?.value || null)}
          placeholder="Select property type"
          disabled={disabled}
          tooltip="Properties can be added in the Other Assets section. Once you've added a Real Estate asset, you will be able to link a mortgage to the property. If you plan on selling the Real Estate asset in the future, linking the property and mortgage will impact the net proceeds you will receive from the sale if the mortgage still has a balance at the time of the sale."
          isPortal
        />
      )}
    />
  );
};
